type PlatformIconProps = { className?: string };

export function ClaudeIcon({ className }: PlatformIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M12 2.5v19M2.5 12h19M5.3 5.3l13.4 13.4M18.7 5.3 5.3 18.7M8.2 2.9l7.6 18.2M15.8 2.9 8.2 21.1M2.9 8.2l18.2 7.6M21.1 8.2 2.9 15.8" />
    </svg>
  );
}

export function ChatGPTIcon({ className }: PlatformIconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M22.282 9.821a6 6 0 0 0-.516-4.91a6.05 6.05 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a6 6 0 0 0-3.998 2.9a6.05 6.05 0 0 0 .743 7.097a5.98 5.98 0 0 0 .51 4.911a6.05 6.05 0 0 0 6.515 2.9A6 6 0 0 0 13.26 24a6.06 6.06 0 0 0 5.772-4.206a6 6 0 0 0 3.997-2.9a6.06 6.06 0 0 0-.747-7.073M13.26 22.43a4.48 4.48 0 0 1-2.876-1.04l.141-.081l4.779-2.758a.8.8 0 0 0 .392-.681v-6.737l2.02 1.168a.07.07 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494M3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085l4.783 2.759a.77.77 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646M2.34 7.896a4.5 4.5 0 0 1 2.366-1.973V11.6a.77.77 0 0 0 .388.677l5.815 3.354l-2.02 1.168a.08.08 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.08.08 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667m2.01-3.023l-.141-.085l-4.774-2.782a.78.78 0 0 0-.785 0L9.409 9.23V6.897a.07.07 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zM8.307 12.863l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.376-3.454l-.142.081L8.704 5.459a.8.8 0 0 0-.393.681zm1.097-2.365l2.602-1.5l2.607 1.5v2.999l-2.597 1.5l-2.607-1.5z" />
    </svg>
  );
}

const platforms = [
  { name: "Claude", Icon: ClaudeIcon },
  { name: "ChatGPT", Icon: ChatGPTIcon },
] as const;

export function HeroAvailability({ label }: { label: string }) {
  return (
    <div className="mx-auto flex w-fit max-w-full flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-medium text-slate-500 sm:text-sm dark:text-slate-300">
      <span>{label}</span>
      <ul className="flex items-center gap-2 sm:gap-3">
        {platforms.map(({ name, Icon }) => (
          <li key={name} className="flex h-6 w-6 items-center justify-center">
            <span
              role="img"
              tabIndex={0}
              aria-label={name}
              className="group relative inline-flex h-6 w-6 cursor-help items-center justify-center rounded-full text-slate-500 outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/60 focus-visible:ring-offset-2 dark:text-slate-400 dark:focus-visible:ring-sky-300/60 dark:focus-visible:ring-offset-slate-950"
            >
              <Icon className="h-5 w-5" />
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -top-8 left-1/2 z-20 -translate-x-1/2 translate-y-1 scale-95 whitespace-nowrap rounded-md border border-slate-200/80 bg-white px-2 py-1 text-xs font-medium text-slate-700 opacity-0 shadow-lg transition-all duration-150 ease-out group-hover:translate-y-0 group-hover:scale-100 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:scale-100 group-focus-visible:opacity-100 dark:border-white/15 dark:bg-slate-900 dark:text-slate-100"
              >
                {name}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
